module.exports = __webpack_public_path__ + "static/media/reopen.7bf41b8a.svg";